$( document ).on("turbo:load", initOrganisationSwitch);

function initOrganisationSwitch() {
  organisationSwitch = $("[data-function='organisation-switch']");
  if (organisationSwitch.length > 0) {
    organisationSwitch.change(function(){
      url = $(this).data("destination");
      id = $(this).val();
      window.location.replace(url + "?organisation_id=" + id);
    });
  }
}
